import { IllegalStateExceptionkoljg5n0nrlr as IllegalStateException } from '../../../../../../../../kotlin-kotlin-stdlib/kotlin/exceptions.mjs';
import { Unit_instance3kz1zqli6gr1r as Unit_instance } from '../../../../../../../../kotlin-kotlin-stdlib/kotlin/Unit.mjs';
import { get_partyIdAdapter2v7zx778kk10s as get_partyIdAdapter } from '../../../adapter/Adapter.mjs';
import { get_StringAdapter1plpsgiy8rwhj as get_StringAdapter } from '../../../../../../../../apollo-kotlin-apollo-api/com/apollographql/apollo/api/Adapters.mjs';
import { THROW_CCE2g6jy02ryeudk as THROW_CCE } from '../../../../../../../../kotlin-kotlin-stdlib/kotlin/hacks.mjs';
import { SaveSlackIntegrationInput3jeifrdutkqgi as SaveSlackIntegrationInput } from '../SaveSlackIntegrationInput.mjs';
import { Adapter1t72m9xaryzfb as Adapter } from '../../../../../../../../apollo-kotlin-apollo-api/com/apollographql/apollo/api/Adapter.mjs';
import { initMetadataForObject1cxne3s9w65el as initMetadataForObject } from '../../../../../../../../kotlin-kotlin-stdlib/kotlin/js/metadataUtils.mjs';
import { VOID3gxj6tk5isa35 as VOID } from '../../../../../../../../kotlin-kotlin-stdlib/kotlin/js/void.mjs';
//region block: imports
//endregion
//region block: pre-declaration
//endregion
var SaveSlackIntegrationInput_InputAdapterClass;
function SaveSlackIntegrationInput_InputAdapter() {
  if (SaveSlackIntegrationInput_InputAdapterClass === VOID) {
    class $ {
      g40(reader, customScalarAdapters) {
        throw IllegalStateException().o('Input type used in output position');
      }
      s6w(writer, customScalarAdapters, value) {
        writer.c4d('partyId');
        get_partyIdAdapter().h40(writer, customScalarAdapters, value.p6v_1);
        writer.c4d('team');
        get_StringAdapter().h40(writer, customScalarAdapters, value.q6v_1);
        writer.c4d('channel');
        get_StringAdapter().h40(writer, customScalarAdapters, value.r6v_1);
      }
      h40(writer, customScalarAdapters, value) {
        return this.s6w(writer, customScalarAdapters, value instanceof SaveSlackIntegrationInput() ? value : THROW_CCE());
      }
    }
    initMetadataForObject($, 'SaveSlackIntegrationInput_InputAdapter', VOID, VOID, [Adapter()]);
    SaveSlackIntegrationInput_InputAdapterClass = $;
  }
  return SaveSlackIntegrationInput_InputAdapterClass;
}
var SaveSlackIntegrationInput_InputAdapter_instance;
function SaveSlackIntegrationInput_InputAdapter_getInstance() {
  return SaveSlackIntegrationInput_InputAdapter_instance;
}
//region block: init
SaveSlackIntegrationInput_InputAdapter_instance = new (SaveSlackIntegrationInput_InputAdapter())();
//endregion
//region block: exports
export {
  SaveSlackIntegrationInput_InputAdapter_instance as SaveSlackIntegrationInput_InputAdapter_instance1qxrj6t17r87b,
};
//endregion

//# sourceMappingURL=SaveSlackIntegrationInput_InputAdapter.mjs.map
